module.exports = __webpack_public_path__ + "img/filter-type-yoga--active.5c344fd0.svg";